var styleDataHash = "10ebb3e5";
const injectCss = () => {
  var css = `.glob_fontElementMap,.kXjlO{font-family:var(--ricos-font-family,unset)}.Aka2U{width:100%}[dir] .Aka2U{margin:8px auto 0}.Aka2U .o2iwd{height:1px}[dir] .Aka2U .o2iwd{background-color:var(--ricos-settings-dividers-color,rgba(51,51,51,.2))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Aka2U .o2iwd{width:100%}[dir] .Aka2U .o2iwd{margin:0}}}@container (width < 640px){.Aka2U .o2iwd{width:100%}[dir] .Aka2U .o2iwd{margin:0}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_section_default = {
  "fontElementMap": "kXjlO",
  "whitespace": "Aka2U",
  "divider": "o2iwd"
};
export {
  list_item_section_default as default,
  injectCss
};
//# sourceMappingURL=list-item-section-scss.js.map
